import React, { useState } from 'react';
import { Box, InputBase, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AccountMenu from './AccountMenu';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSelect from '../common/LanguageSelect';
import { fmtDateWith } from '../../utils/format';

const greetingKey = () => {
    const h = new Date().getHours();
    if (h >= 5 && h < 12) return 'topbar.morning';
    if (h >= 12 && h < 17) return 'topbar.afternoon';
    return 'topbar.evening';
};

export default function TopBar() {
    const { t } = useTranslation();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [q, setQ] = useState('');

    const submit = (e) => {
        e.preventDefault();
        const term = q.trim();
        navigate(term ? `/jobs?q=${encodeURIComponent(term)}` : '/jobs');
        setQ('');
    };

    return (
        <Box sx={{
            position: 'sticky', top: 0, zIndex: 10, bgcolor: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)',
            borderBottom: '1px solid #EEF2F6', px: { xs: 2, sm: 3 }, py: 1.25,
            display: 'flex', alignItems: 'center', gap: 2,
        }}>
            <Box sx={{ display: { xs: 'none', md: 'block' }, minWidth: 0 }}>
                <Typography noWrap sx={{ fontWeight: 700, color: '#2c3e50', fontSize: 15 }}>
                    {t(greetingKey())}{user?.firstName ? `, ${user.firstName}` : ''}
                </Typography>
                <Typography noWrap sx={{ fontSize: 12.5, color: '#7f8c9a' }}>
                    {fmtDateWith(new Date(), { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                </Typography>
            </Box>

            {/* Global search: jumps to the jobs list filtered by the term (client, zone, parcel, number...). */}
            <Box component="form" onSubmit={submit} sx={{
                flex: 1, maxWidth: 460, ml: { md: 'auto' }, display: 'flex', alignItems: 'center', gap: 1,
                bgcolor: '#F1F5F9', borderRadius: '10px', px: 1.5, py: 0.6, border: '1px solid transparent',
                '&:focus-within': { bgcolor: '#fff', borderColor: '#cfe0ea', boxShadow: '0 0 0 3px rgba(66,120,152,0.10)' },
            }}>
                <SearchIcon sx={{ fontSize: 19, color: '#94A3B8' }} />
                <InputBase value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('topbar.search')}
                           inputProps={{ 'aria-label': t('topbar.search') }} sx={{ flex: 1, fontSize: 13.5 }} />
            </Box>

            <Box sx={{ ml: { xs: 'auto', md: 1 }, display: 'flex', alignItems: 'center', gap: 1 }}>
                <LanguageSelect />
                <AccountMenu />
            </Box>
        </Box>
    );
}
